"use client";

// Google Analytics 4 (GA4) — meowmitattoo.com
// Measurement ID 來自環境變數 NEXT_PUBLIC_GA_ID,沒設時退回站台預設值。
// GA4 measurement ID 本來就會出現在瀏覽器端,屬於公開值,寫死作為 fallback 是安全的。
import Script from "next/script";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect, useRef } from "react";

const GA_ID = process.env.NEXT_PUBLIC_GA_ID || "G-X0WPWKNFSS";
// Google Ads conversion account (e.g. "AW-1234567890"). Optional — when set it
// rides on the gtag.js already loaded for GA4, so the purchase conversion in
// lib/analytics.js (send_to: "AW-…/label") is registered. Empty = no Ads tag.
const ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID || "";

// App Router 是單頁應用(client-side navigation),只有第一次載入會觸發
// gtag config 的自動 page_view。之後切頁不會重整,需要手動補送 page_view。
function PageviewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // 第一次 page_view 由下方 gtag('config') 自動送出,這裡跳過避免重複計算。
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (typeof window.gtag !== "function") return;

    const qs = searchParams?.toString();
    const url = qs ? `${pathname}?${qs}` : pathname;
    window.gtag("event", "page_view", {
      page_path: url,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, searchParams]);

  return null;
}

export default function GoogleAnalytics() {
  if (!GA_ID) return null;

  return (
    <>
      {/* lazyOnload: gtag.js 180KB 是行動端 TTI 最大單一元凶,改成頁面
          載完才載。追蹤照常送出,只是晚幾秒;極短停留(<載入完成)的
          跳出訪客可能漏計,屬已知取捨。 */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="lazyOnload"
      />
      <Script id="ga-init" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}');
          ${ADS_ID ? `gtag('config', '${ADS_ID}');` : ""}
        `}
      </Script>
      <Suspense fallback={null}>
        <PageviewTracker />
      </Suspense>
    </>
  );
}
